interface IProps {
  content: any;
}

const Head = ({ content }: IProps) => {
  return content;
};

export default Head;
